<template>

    <div class="simulator-box">

        <div class="flex-row">
            <div class="col-xs">
                <h2 class="simulator-title" :class="{'loaded' : filho.educacao_filho_id, 'with-animation' : carregando}">
                    Despesas do filho(a) <span class="grey-text text-lighten-1">{{ filho.nome }}</span>
                </h2>
            </div>
            <div class="col-xs flex-no-grow">

            </div>
        </div>


        <div class="flex-row">
            <div class="col-xs-12 col-sm-6 col-md-4"
                v-for="(formacao, index) in formacao_filhos"
                :key="formacao.formacao_filho_id">

                <form-despesa-filho
                    :formacao="formacao"
                    class="card-panel"
                    v-model="formacao.despesa"
                    @delete="confirmarExclusao(formacao.despesa, index)"
                    @input="salvar(formacao.despesa, index)" />
            </div>
        </div>

        <div class="input-field end-xs">
            <router-link :disabled="carregando" class="btn btn-default" :to="{name: 'cliente_educacao_filhos', params: {id: filho.cliente_id}}">
                {{ carregando ? 'Salvando...' : 'Voltar' }}
            </router-link>
        </div>
    </div>
</template>


<script>

import { put, get, post, remove } from "@/helpers/api";
import swal from 'sweetalert2';
import FormDespesaFilho from '@/components/common/FormDespesaFilho.vue';

import modal from '@/helpers/wm-modal.js'


export default {

    name: 'despesas-filho',

    components: {FormDespesaFilho},

    async created() {

        await this.carregarFormacoes();

        await this.carregarFilho();
    },

    data() {
        return {
            formacao_filhos: [],
            filho: {},
            despesas: [],
            carregando: false,
        }
    },

    methods: {


        async confirmarExclusao(despesa)
        {
            const resultado = await modal.confirm({
                text: "Confirma a exclusão desse item?",
                title: "Confirmação"
            })

            if (! resultado) return;

            await this.excluir(despesa);
        },

        async excluir(despesa) {

            await remove(`despesa-educacao-filho/${despesa.despesa_educacao_filho_id}`);

             Object.assign(despesa, {
                despesa_educacao_filho_id: null,
                custo_mensal: '',
                anos_restantes: null,
                meses_restantes: null,
            });
        },

        async salvar(despesa, index) {

            this.carregando = true;

            try {
                let {data: {result: {data: resultado}}} = await put('despesa-educacao-filho', despesa);

                this.$set(despesa, 'despesa_educacao_filho_id', resultado.despesa_educacao_filho_id);

            } finally {
                setTimeout(() => this.carregando = false, 2000);
            }
        },

        async carregarFilho() {

            let {data: {result: {data: filho}}} = await get(`educacao-filho/${this.$route.params.id}`);

            this.filho = filho;

            this.formacao_filhos.forEach(formacao  => {

                const despesa = filho.despesas.find(despesa => (
                    despesa.formacao_filho_id == formacao.formacao_filho_id
                ));

                this.$set(formacao, 'despesa', {
                    formacao_filho_id: formacao.formacao_filho_id,
                    custo_mensal: null,
                    anos_restantes: null,
                    educacao_filho_id: this.$route.params.id,
                    ...despesa
                });

            })

        },

        async carregarFormacoes() {

            let {data: {result: {data: formacao_filhos}}} = await get('formacao-filho');

            this.formacao_filhos = formacao_filhos;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/clientes/DespesaFilho.vue